import { render, staticRenderFns } from "./MWidgetTagAndCookieCsv.vue?vue&type=template&id=162165b7&scoped=true&lang=pug&"
import script from "./MWidgetTagAndCookieCsv.vue?vue&type=script&lang=js&"
export * from "./MWidgetTagAndCookieCsv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162165b7",
  null
  
)

export default component.exports